"use client"
import { MdMoreVert } from "react-icons/md";
import {useState} from "react";
import RechtermuisClickMenu from "hooks/rechtermuisclickmenu";
import styles from "./RightMouseClickMenu.module.scss";

export const RightMouseClickMenu = ({id, weergaveId, bewerkMenuCurrent,bewerkMenuPrev, bewerkMenuNext}) =>{

    const [showMenu, setShowMenu] = useState(false)


    function handleShow(e){
        e.preventDefault()
        setShowMenu(!showMenu)
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.iconWrapper}>
                {showMenu && (
                    <RechtermuisClickMenu
                        weergaveId={weergaveId}
                        show={showMenu}
                        setShow={setShowMenu}
                        contentItemId={id}
                        volgordePrev={bewerkMenuPrev}
                        volgordeCurrent={bewerkMenuCurrent}
                        volgordeNext={bewerkMenuNext}
                        menuClassName={styles.menu}
                        menuItemClassName={styles.menuItem}
                        dividerClassName={styles.divider}
                    />
                )}
                <MdMoreVert
                    title={`opties..`}
                    onClick={handleShow}
                    onContextMenu={handleShow}
                    className={`text-kleur-cyan text-xl cursor-pointer`}
                />
            </div>
        </div>
    );
}